import { touchWebClient } from 'tradera/utils/http';

const publish = async (draft, hasTraderaPayConsent) => {
    let data;
    try {
        const response = await touchWebClient.post('/selling/api/items', {
            draft: {
                ...draft,
                shippingOptions: draft.shippingOptions.filter(
                    (item) => !!item.type
                ),
                descriptionLanguageCodeIso2:
                    draft.descriptionLanguageCodeIso2 || 'sv',
                currency: draft.currency || 'SEK'
            },
            hasTraderaPayConsent: hasTraderaPayConsent
        });

        data = response.data;
    } catch ({ response }) {
        data = response.data;
    }

    if (data.errorCode) throw data;

    return data;
};

export default {
    publish
};
